import * as React from "react";

const IconSubirScroll = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="39"
    height="39"
    fill="none"
    viewBox="0 0 39 39"
    style={{
      cursor: "pointer",
    }}
    {...props}
  >
    <rect
      width="39"
      height="39"
      fill="#171717"
      fillOpacity="0.27"
      rx="10"
    ></rect>
    <path
      fill="#F2EEFD"
      d="M12.2 23.791c.099.118.31.209.46.209.175 0 1.396-1.174 3.851-3.744L20.1 16.5l3.589 3.756c2.455 2.57 3.676 3.744 3.85 3.744.287 0 .661-.313.661-.56 0-.236-7.888-8.44-8.1-8.44-.224 0-8.1 8.204-8.1 8.44 0 .077.087.247.2.351"
    ></path>
  </svg>
);

export default IconSubirScroll;
